import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import Breadcrumb from 'components/Breadcrumb'
import Spinner from 'react-spinkit'

import PageTitle from './PageTitle'
import PitchRow from './PitchRow'

const Summary = props => (
  <div className="page-content">
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="portlet light portlet-fit">
          <div className="portlet-title">
            <div className="caption">
              <span className="caption-subject font-dark bold uppercase">
                {props.data.name}
              </span>
            </div>
          </div>
          <div className="portlet-body" style={{ overflow: 'scroll' }}>
            <table className="table table-striped table-bordered table-hover project-detail">
              <thead>
                <tr>
                  <th> Project Name </th>
                  <th> Client PIC </th>
                  <th> Client Email </th>
                  <th> Client Phone No. </th>
                  <th> Client Terms of Payment </th>
                  <th> Country </th>
                  <th> Currency </th>
                  <th> Quotation No. </th>
                  <th> Invoice Number #1 </th>
                  <th> Invoice Number #2 </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width={150}>{props.data.name}</td>
                  <td width={200}>
                    {`${props.data.user.firstName} ${props.data.user.lastName}`}
                  </td>
                  <td>{props.data.user.email}</td>
                  <td>
                    {props.data.user.phone_number ? props.data.user.phone_number : '-'}
                  </td>
                  <td width={500}>{props.top.clientLabel}</td>
                  <td width={150}>{props.data.country.name}</td>
                  <td width={150}>{props.data.country.currencyCode}</td>
                  <td width={200}>
                    {props.quotation.count > 0 ? (
                      <Link to={props.quotation.rows[0].url} target="_blank">
                        {props.quotation.rows[0].quotationNumber}
                      </Link>
                    ) : (
                      '-'
                    )}
                  </td>
                  {props.invoices.rows.length ? (
                    <td width={200}>
                      <Link to={props.invoices.rows[0].url} target="_blank">
                        {props.invoices.rows[0].invoiceNumber}
                      </Link>
                    </td>
                  ) : (
                    <td width={200}>N/A</td>
                  )}
                  {props.invoices.rows[1] ? (
                    <td width={200}>
                      <Link to={props.invoices.rows[1].url} target="_blank">
                        {props.invoices.rows[1].invoiceNumber}
                      </Link>
                    </td>
                  ) : (
                    <td width={200}>N/A</td>
                  )}
                </tr>
              </tbody>
            </table>
            <div style={{ padding: '5px 0 10px' }}>
              <div style={{ fontWeight: '600' }}>Filter Pitch Status:</div>
              <div className="mt-radio-list">
                <label htmlFor="allopt" className="mt-radio mt-radio-outline">
                  {' '}
                  All
                  <input
                    onChange={props.handleRadioStatus(
                      props.selectedRadioPitchStatus,
                      props.data.id
                    )}
                    type="radio"
                    value="all"
                    id="allopt"
                    name="all-status"
                    checked={props.selectedRadioPitchStatus === 'all'}
                  />
                  <span />
                </label>
                <label htmlFor="approv" className="mt-radio mt-radio-outline">
                  {' '}
                  Selected
                  <input
                    onChange={props.handleRadioStatus(
                      props.selectedRadioPitchStatus,
                      props.data.id
                    )}
                    type="radio"
                    value="approved"
                    id="approv"
                    name="approve"
                    checked={props.selectedRadioPitchStatus === 'approved'}
                  />
                  <span />
                </label>
                <label htmlFor="withdrw" className="mt-radio mt-radio-outline">
                  {' '}
                  Withdraw
                  <input
                    onChange={props.handleRadioStatus(
                      props.selectedRadioPitchStatus,
                      props.data.id
                    )}
                    type="radio"
                    value="withdraw"
                    id="withdrw"
                    name="withdrawed"
                    checked={props.selectedRadioPitchStatus === 'withdraw'}
                  />
                  <span />
                </label>
                <label htmlFor="drft" className="mt-radio mt-radio-outline">
                  {' '}
                  Draft
                  <input
                    onChange={props.handleRadioStatus(
                      props.selectedRadioPitchStatus,
                      props.data.id
                    )}
                    type="radio"
                    value="draft"
                    id="drft"
                    name="drafted"
                    checked={props.selectedRadioPitchStatus === 'draft'}
                  />
                  <span />
                </label>
                <label htmlFor="rejectd" className="mt-radio mt-radio-outline">
                  {' '}
                  Not Selected
                  <input
                    onChange={props.handleRadioStatus(
                      props.selectedRadioPitchStatus,
                      props.data.id
                    )}
                    type="radio"
                    value="rejected"
                    id="rejectd"
                    name="reject"
                    checked={props.selectedRadioPitchStatus === 'rejected'}
                  />
                  <span />
                </label>
              </div>
            </div>
            <div
              className="table-responsive"
              style={{ width: '3000px', overflow: 'scroll' }}
            >
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th> Action </th>
                    <th width="300"> GetPaid Status </th>
                    <th> Name </th>
                    <th> Service Type </th>
                    <th> Description </th>
                    <th> Qty </th>
                    <th> Estimated Views </th>
                    <th> CPV </th>
                    <th> Total Client Price </th>
                    <th> Pay To Creator </th>
                    <th> Pitch Status </th>
                    <th> Email </th>
                    <th> Phone No. </th>
                    <th> PO No. </th>
                    <th> Pitch Link </th>
                    <th> Project Invitation Link </th>
                    <th> Bank Name </th>
                    <th> Bank Account # </th>
                    <th> Creator&apos;s Registered Name in Bank </th>
                    <th> Creative Idea </th>
                  </tr>
                </thead>

                {!props.selectedPitchLoading && (
                  <tbody>
                    {props.pitches.map(pitch => (
                      <PitchRow
                        key={pitch.id}
                        pitch={pitch}
                        poCreator={props.poCreator}
                        goesTopPlatform={props.goesTopPlatform}
                        data={props.data}
                        userEmail={props.userEmail}
                        calculate={props.calculate}
                        putGetPaidStatus={props.putGetPaidStatus}
                        isProjectStarted={props.isProjectStarted}
                      />
                    ))}

                    <tr>
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                    </tr>
                  </tbody>
                )}
              </table>

              {props.selectedPitchLoading && (
                <div
                  style={{
                    paddingTop: '150px',
                    paddingBottom: '150px',
                    marginLeft: '650px',
                  }}
                >
                  <span style={{ marginLeft: '-20px' }}>Fetching datas</span>
                  <Spinner
                    spinnerName="ball-scale-ripple"
                    color="purple"
                    style={{ marginTop: '10px' }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

Summary.propTypes = {
  pitches: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.shape({
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
      currencyCode: PropTypes.string.isRequired,
    }).isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      phone_number: PropTypes.string,
    }).isRequired,
  }).isRequired,
  top: PropTypes.shape({
    clientLabel: PropTypes.string.isRequired,
  }).isRequired,
  quotation: PropTypes.shape({
    count: PropTypes.number.isRequired,
    rows: PropTypes.array.isRequired,
  }).isRequired,
  invoices: PropTypes.shape({
    rows: PropTypes.array.isRequired,
  }).isRequired,

  selectedPitchLoading: PropTypes.bool.isRequired,
  isProjectStarted: PropTypes.bool.isRequired,
  selectedRadioPitchStatus: PropTypes.string.isRequired,
  handleRadioStatus: PropTypes.func.isRequired,
}

export default Summary
